module.exports = __webpack_public_path__ + "img/start_bg.b3c105db.png";